import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import menuModule from './modules/menu';
import socketMessage from './modules/socketMessage';
import records from './modules/records';
import globalModal from './modules/globalModal';
import company from './modules/company';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '',
    pcToken: '',
    tempToken: '', // 注册支付页面使用的临时token
    userBrief: {
      realName: '',
      companyType: '', // 用户公司类型：取值参见constants->COMPANYTYPE_ ,
      role: '', // 用户角色：0-超级管理员 1-普通管理员
      providerId: '', // 供应商id
      encryptionId: '', // 加密的供应商id
      status: '', // 用户状态：0-审核中 1-正常（已审核通过） 2-审核未通过 3-禁用 4-独立注册待编辑
      phone: '', // 当前用户绑定的手机号码
      companyName: '', // 企业名,
      companyId: '', // 企业ID
      sealName: '', // 印章名称
      needInitialSet: false, // 供应商端初始设置状态
      companyStatus: 999,
      phoneNo: '' // 手机号码
    },
    registerStep: 0,
    nonUser: {
      phone: '',
      password: '',
      token: '',
      regType: 2
    },
    supplierShowSetPayStatus: false, // 是否显示过提示供应商设置支付密码状态
    menus: [], // 权限菜单类表
    menuIds: [], // 全部菜单ID
    changeCompanyId: -1
  },
  mutations,
  actions,
  getters: {
    getToken(state) {
      const localToken = localStorage.getItem('token');
      if (localToken) {
        state.token = localToken;
      }
      return state.token;
    },
    isSuperManager(state) {
      return state.userBrief.role === 0;
    }
  },
  modules: {
    menuModule,
    socketMessage,
    records,
    globalModal,
    company,
  }
});
